// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AoNYs","importantInfo":"styles_importantInfo__1ylIf"};